export default (arr, filter, key) => {
  const filterUpperCase = filter.toUpperCase();

  return arr.filter((val) => {
    const valUpperCase = val[key].toUpperCase();

    if (valUpperCase.indexOf(filterUpperCase) !== -1) {
      return val;
    }

    return false;
  });
};
